<template>
  <div>
    <el-table :data="userData" style="width: 100%" border>
      <el-table-column label="用户名" prop="loginName"></el-table-column>
      <el-table-column label="邮箱" prop="email"></el-table-column>
      <el-table-column label="创建日期" prop="createTime"></el-table-column>
      <el-table-column label="备注" prop="remark"></el-table-column>
      <el-table-column label="操作" width="100px">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-dialog title="基本信息" :visible.sync="dialogFormVisible">
            <el-form :model="userxinxi" label-width="80px">
              <el-form-item label="用户名">
                <el-input v-model="userxinxi.loginName" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="邮箱">
                <el-input v-model="userxinxi.email" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="创建日期">
                <el-input v-model="userxinxi.createTime" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="启用/禁用">
                <el-switch v-model="userxinxi.delivery" active-value="0" inactive-value="1"></el-switch>
              </el-form-item>
              <el-form-item label="角色">
                <el-checkbox-group v-model="userxinxi.type">
                  <el-checkbox
                    v-for="item in userxinxi.RoleName"
                    :key="item.id"
                    :label="item.id"
                  >{{item.roleName}}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="备注">
                <el-input type="textarea" v-model="userxinxi.desc"></el-input>
              </el-form-item>
              <el-button type="primary" @click="Jurisdiction()">确 定</el-button>
              <el-button @click="dialogFormVisible = false">取 消</el-button>
            </el-form>
          </el-dialog>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next, sizes, total, jumper"
      :total="totalPage"
      :page-sizes="[5, 10, 15, 20]"
      :page-size="pagesize"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    ></el-pagination>
  </div>
</template>
  <script>
export default {
  data() {
    return {
      dialogFormVisible: false,
      userData: [],
      pagesize: 10,
      currpage: 1,
      totalPage: 0,
      totalCount: 0,
      userxinxi: {
        delivery: "",
        type: [],
        RoleName: [],
        huichuanid: "",
        desc: "",
      },
    };
  },
  mounted() {
    this.userchaxun();
  },
  methods: {
    userchaxun() {
      let formData = new FormData();
      formData.append("pageSize", Number(this.pagesize));
      formData.append("cpage", Number(this.currpage));
      this.$http
        .post(this.$getaxiosurl("/user/user/getALLUser"), formData)
        .then((response) => {
          if (response.data.code == "00100") {
            this.currpage = response.data.data.cpage;
            this.totalPage = response.data.data.totalCount;
            this.totalCount = response.data.data.totalCount;
            this.userData = response.data.data.users;
          } else {
            this.$message({
              message: response.data.msg,
              type: "success",
              duration: 8000,
            });
          }
        });
    },
    Jurisdiction() {
      let formData = new FormData();
      formData.append("id", this.userxinxi.id);
      formData.append("status", this.userxinxi.delivery);
      formData.append("roles", String(this.userxinxi.type));
      formData.append("remark", this.userxinxi.desc);
      this.$http
        .post(this.$getaxiosurl("/user/user/editUser"), formData)
        .then((response) => {
          if (response.data.code == "00100") {
            this.$message({
              showClose: true,
              message: response.data.msg,
              type: "success",
            });
            this.dialogFormVisible = false;
            this.userData = [];
            this.userchaxun();
          } else {
            if (response.data.code != "00100") {
              this.$message({
                showClose: true,
                message: response.data.msg,
                type: "error",
              });
            }
          }
        });
    },
    handleEdit(index, row) {
      Object.assign(this.userxinxi, row);
      this.userxinxi.type = [];
      this.userxinxi.delivery = "";
      this.userxinxi.desc = "";
      let formData = new FormData();
      formData.append("userId", this.userxinxi.id);
      this.$http
        .post(this.$getaxiosurl("/user/user/getUserByUserId"), formData)
        .then((response) => {
          if (response.data.code == "00100") {
            this.userxinxi.delivery = response.data.user.status;
            this.userxinxi.desc = response.data.user.remark;
            this.userxinxi.type = response.data.roles;
            if (this.userxinxi.RoleName.length == 0) {
              for (var i = 0; i < response.data.allRole.length; i++) {
                this.userxinxi.RoleName.push(response.data.allRole[i]);
              }
            }
          } else {
            this.$message({
              message: response.data.msg,
              type: "success",
              duration: 8000,
            });
          }
        });
      this.dialogFormVisible = true;
    },
    handleCurrentChange(cpage) {
      let formData = new FormData();
      formData.append("pageSize", Number(this.pagesize));
      formData.append("cpage", Number(cpage));
      this.$http
        .post(this.$getaxiosurl("/user/user/getALLUser"), formData)
        .then((response) => {
          if (response.data.code == "00100") {
            this.currpage = response.data.data.cpage;
            this.totalPage = response.data.data.totalCount;
            this.userData = response.data.data.users;
          } else {
            this.$message({
              message: response.data.msg,
              type: "success",
              duration: 8000,
            });
          }
        });
    },
    handleSizeChange(psize) {
      let formData = new FormData();
      formData.append("pageSize", Number(psize));
      formData.append("cpage", Number(this.currpage));
      this.$http
        .post(this.$getaxiosurl("/user/user/getALLUser"), formData)
        .then((response) => {
          if (response.data.code == "00100") {
            this.currpage = response.data.data.cpage;
            this.totalPage = response.data.data.totalCount;
            this.pagesize = response.data.data.pageSize;
            this.userData = response.data.data.users;
          } else {
            this.$message({
              message: response.data.msg,
              type: "success",
              duration: 8000,
            });
          }
        });
    },
  },
};
</script>
<style scoped>
</style>